@if (!isProjectPage) {
  <app-project-overview
    (newProjectTrigger)="this.openAddProject()"
    >
  </app-project-overview>
}

@if (isProjectPage) {
  <app-project-bots-tab
    [bots]="this.projectService.filterBots()"
    (deleteBot)="this.deleteBot($event)"
    (duplicateTrigger)="this.projectService.loadBots()"
    (reloadTrigger)="this.projectService.loadBots()"
    >
  </app-project-bots-tab>
}
